import { render, staticRenderFns } from "./TableAccountsReceivable.vue?vue&type=template&id=00b4c72b"
import script from "./TableAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./TableAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./TableAccountsReceivable.vue?vue&type=style&index=0&id=00b4c72b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports